module.exports = __webpack_public_path__ + "img/1_1.5c97c249.png";